import { render, staticRenderFns } from "./PromotionPlan.vue?vue&type=template&id=e58622f4"
import script from "./PromotionPlan.vue?vue&type=script&lang=js"
export * from "./PromotionPlan.vue?vue&type=script&lang=js"
import style0 from "./PromotionPlan.vue?vue&type=style&index=0&id=e58622f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports